import * as yup from "yup";
export const changePasswordSchema = yup.object({
  password: yup.string().required("Password is required").min(8, "Too Short!"),
  password2: yup
    .string()
    .oneOf([yup.ref("password"), null], "Password do not match")
    .required("Required"),
});
